import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Outlet } from "react-router-dom";
import { Paper } from "matsuri-ui";
import { css } from "@emotion/react";
import { AppHeader } from "../../parts/AppHeader";
export const AuthPageLayout = () => {
    return (_jsxs("div", { children: [_jsx(AppHeader, {}), _jsx(Paper, { css: css `
          width: min(540px, 100vw);
          min-height: min(400px, 100vh);
          padding: 32px 32px 0px;
          margin: 24px auto 160px;
          @media (max-width: 540px) {
            margin-top: 0px;
            box-shadow: none;
          }
        `, children: _jsx("div", { css: css `
            display: flex;
            flex-direction: column;
            gap: 32px;
          `, children: _jsx(Outlet, {}) }) })] }));
};
